import { render, staticRenderFns } from "./InlineTableControler.vue?vue&type=template&id=35215feb&scoped=true&"
import script from "./InlineTableControler.vue?vue&type=script&lang=js&"
export * from "./InlineTableControler.vue?vue&type=script&lang=js&"
import style0 from "./InlineTableControler.vue?vue&type=style&index=0&id=35215feb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35215feb",
  null
  
)

export default component.exports